import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Tooltip, IconButton } from '@mui/material';
import StyledMainMenuCollapseButton from 'common/theme/menu/StyledMainMenuCollapseButton';
import StyledCollapsibleMenuIcon from 'common/theme/icon/StyledCollapsibleMenuIcon';
import StyledCollapsibleMenuItemIcon from 'common/theme/icon/StyledCollapsibleMenuItemIcon';
import StyledCollapsibleMenuLisItemButtom from 'common/theme/button/StyledCollapsibleMenuLisItemButtom';
import StyledMenuItemLink from 'common/theme/links/StyledMenuItemLink';
import StyledMenuItemText from 'common/theme/typography/text/StyledMenuItemText';

function CollapsibleMenuItemToggle({
  icon,
  iconOnly = false,
  isActive = false,
  label,
  noLink = false,
  onClick,
  open,
  path
}) {
  if (iconOnly) {
    return (
      <StyledCollapsibleMenuLisItemButtom noLink={noLink} selected={isActive}>
        <Tooltip title={label} placement="right">
          {noLink ? (
            <IconButton
              onClick={onClick}
              sx={{
                minWidth: 'auto',
                minHeight: 46,
                padding: '8px',
                width: '100%',
                borderRadius: '13px',
                color: 'inherit'
              }}
            >
              <StyledCollapsibleMenuItemIcon sx={{ margin: '0 auto' }}>
                {icon}
              </StyledCollapsibleMenuItemIcon>
            </IconButton>
          ) : (
            <StyledMenuItemLink component={NavLink} to={path}>
              <StyledCollapsibleMenuItemIcon sx={{ margin: '0 auto' }}>
                {icon}
              </StyledCollapsibleMenuItemIcon>
            </StyledMenuItemLink>
          )}
        </Tooltip>
      </StyledCollapsibleMenuLisItemButtom>
    );
  }

  return (
    <StyledCollapsibleMenuLisItemButtom noLink={noLink} selected={isActive}>
      {noLink ? (
        <StyledMainMenuCollapseButton
          variant="text"
          endIcon={open ? <ExpandLess /> : <ExpandMore />}
          onClick={onClick}
          startIcon={icon}>
          {label}
        </StyledMainMenuCollapseButton>
      ) : (
        <>
          <StyledMenuItemLink component={NavLink} to={path}>
            <StyledCollapsibleMenuItemIcon>{icon}</StyledCollapsibleMenuItemIcon>
            <StyledMenuItemText primary={label} />
          </StyledMenuItemLink>
          <StyledCollapsibleMenuIcon aria-label="collapse" onClick={onClick}>
            {open ? <ExpandLess /> : <ExpandMore />}
          </StyledCollapsibleMenuIcon>
        </>
      )}
    </StyledCollapsibleMenuLisItemButtom>
  );
}

CollapsibleMenuItemToggle.propTypes = {
  icon: PropTypes.object.isRequired,
  iconOnly: PropTypes.bool,
  isActive: PropTypes.bool,
  label: PropTypes.string.isRequired,
  noLink: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired
};

export default CollapsibleMenuItemToggle;
